
























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';

import IndexFooter from '@/components/IndexFooter.vue';
import Breadcrumb from './components/Breadcrumb.vue';

@Component({ components: { IndexFooter, Breadcrumb } })
export default class LoginComponent extends Vue {
  navArr = [];

  mounted() {}
}
